import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TableCasino from '../../components/table';
import Title from '../../../../../@casino/ui/title';
import { setGroups } from '../../store/thunk/setGroups';

const ReportGroupList = () => {
    const dispatch = useDispatch();
        
    const [search, setSearch] = React.useState('');

    React.useEffect(() => {
        dispatch(setGroups({
            group: '',
            hide: false
        }));
    }, []);

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'label', label: 'Название'}
    ];
    
    const groups = useSelector(state => state.groups.list);

    const getRow = (val) => {
        return  val.map((item) => {
            return {
                id: item.id,
                label: item.groups
            }
        })
    }

    const row = React.useMemo(() => getRow(groups && groups.length ? groups : []), [groups])
 
    return (
        <div style={{
            padding: 20,
            paddingTop: 0,
        }}>
            <Title label="Группы"/>
            <div style={{
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <input 
                    type="text"
                    placeholder="Поиск"
                    style={{
                        padding: 10,
                        background: '#141b33',
                        paddingLeft: 10,
                        border: '1px solid #141b33',
                        color: '#fff',
                        outline: 'none',
                        margin: 10,
                        width: '97.3%'
                    }}
                    value={search}
                    onChange={(v) => {
                        dispatch(setGroups({
                            group: v.target.value,
                        }));
                        setSearch(v.target.value);
                    }}
                />
            </div>
            <div style={{
                padding: 20, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <TableCasino
                    columns={columns}
                    width={300}
                    rows={row}
                /> 
            </div>
        </div>
    )
}

export default ReportGroupList;